import { requireElementById, requireElementOfType, requireQuerySelectorHTML } from './utils.js';

function isCanvas(el: Element): el is HTMLCanvasElement {
  return el instanceof HTMLCanvasElement;
}

function isSelect(el: Element): el is HTMLSelectElement {
  return el instanceof HTMLSelectElement;
}

function isButton(el: Element): el is HTMLButtonElement {
  return el instanceof HTMLButtonElement;
}

function isInput(el: Element): el is HTMLInputElement {
  return el instanceof HTMLInputElement;
}

export interface CardElements {
  readonly card: HTMLElement;
  readonly value: HTMLElement;
  readonly pulse: HTMLElement;
}

export interface DomRefs {
  readonly flash: HTMLElement;
  readonly roster: HTMLElement;
  readonly rosterEmpty: HTMLElement;
  readonly uniqueCount: HTMLElement;
  readonly rosterSort: HTMLSelectElement;
  readonly feed: HTMLElement;
  readonly chartBars: HTMLElement;
  readonly chartViewport: HTMLElement;
  readonly chartPeak: HTMLElement;
  readonly chartNow: HTMLElement;
  readonly totalCount: HTMLElement;
  readonly rateLabel: HTMLElement;
  readonly bg: HTMLCanvasElement;
  readonly countSuccess: HTMLElement;
  readonly countFailure: HTMLElement;
  readonly costTotal: HTMLElement;
  readonly cards: { readonly success: CardElements; readonly failure: CardElements };
  readonly soundToggle: HTMLButtonElement;
  readonly internalToggle: HTMLButtonElement;
  readonly soundVolume: HTMLInputElement;
  readonly soundVolumeWrap: HTMLElement;
  readonly soundVolumeProgress: HTMLElement;
}

function buildCard(selector: string): CardElements {
  const card = requireQuerySelectorHTML(document, selector);
  const value = requireQuerySelectorHTML(card, '.card__value');
  const pulse = requireQuerySelectorHTML(card, '.card__pulse');
  return { card, value, pulse };
}

export function collectDom(): DomRefs {
  return {
    flash: requireElementById('flash'),
    roster: requireElementById('roster'),
    rosterEmpty: requireElementById('rosterEmpty'),
    uniqueCount: requireElementById('uniqueCount'),
    rosterSort: requireElementOfType('rosterSort', isSelect),
    feed: requireElementById('feed'),
    chartBars: requireElementById('chartBars'),
    chartViewport: requireElementById('chartViewport'),
    chartPeak: requireElementById('chartPeak'),
    chartNow: requireElementById('chartNow'),
    totalCount: requireElementById('totalCount'),
    rateLabel: requireElementById('rateLabel'),
    bg: requireElementOfType('bg', isCanvas),
    countSuccess: requireElementById('count-success'),
    countFailure: requireElementById('count-failure'),
    costTotal: requireElementById('costTotal'),
    cards: {
      success: buildCard('.card--success'),
      failure: buildCard('.card--failure'),
    },
    soundToggle: requireElementOfType('soundToggle', isButton),
    internalToggle: requireElementOfType('internalToggle', isButton),
    soundVolume: requireElementOfType('soundVolume', isInput),
    soundVolumeWrap: requireElementById('soundVolumeWrap'),
    soundVolumeProgress: requireElementById('soundVolumeProgress'),
  };
}
